<template>
    <div>
        <div class="">
            <h1 class="title is-1">{{ $t('menu.about_us') }}</h1>
        </div>
        
        <div class="section">
            <div class="content">
                <h2 class="title is-2">{{ $t('about_us.ch1_title') }}</h2>
                <p>{{ $t('about_us.ch1_p1') }}</p>
                <p>{{ $t('about_us.ch1_p2')}}</p>
                <div class="columns">
                    <div class="column is-variable is-6 is-offset-3">
                        <video-player class="vjs-custom-skin is-center-image"
                                        ref="videoPlayer"
                                        :options="playerOptions"
                                        :playsinline="true"
                                        @play="onPlayerPlay($event)"
                                        @pause="onPlayerPause($event)"
                                        @ended="onPlayerEnded($event)"
                                        @loadeddata="onPlayerLoadeddata($event)"
                                        @waiting="onPlayerWaiting($event)"
                                        @playing="onPlayerPlaying($event)"
                                        @timeupdate="onPlayerTimeupdate($event)"
                                        @canplay="onPlayerCanplay($event)"
                                        @canplaythrough="onPlayerCanplaythrough($event)"
                                        @ready="playerReadied"
                                        @statechanged="playerStateChanged($event)">
                        </video-player>
                    </div>
                </div>
                <p>{{ $t('about_us.ch1_p3')}}</p>
                <p>{{ $t('about_us.ch1_p4')}}</p>
                <p>{{ $t('about_us.ch1_p5')}}</p>
                <p>{{ $t('about_us.ch1_p6') }}</p>
                <p>{{ $t('about_us.ch1_p7') }}</p>
                <p>{{ $t('about_us.ch1_p8') }}</p>
                <div class="columns">
                    <div class="column">
                        <img :src="images.sprite[0]"  @click="openImage(0)"/>
                    </div>
                    <div class="column">
                        <img :src="images.sprite[1]"  @click="openImage(1)"/>
                    </div>
                </div>
                <p>{{ $t('about_us.ch1_p9') }}</p>
                <p>{{ $t('about_us.ch1_p10') }}</p>
                <p>{{ $t('about_us.ch1_p11') }}</p>
                <div class="columns">
                    <div class="column">
                        <img :src="images.sprite[2]"  @click="openImage(2)"/>
                    </div>
                    <div class="column">
                        <img :src="images.sprite[3]"  @click="openImage(3)"/>
                    </div>
                </div>
                <h2 class="title is-2">{{ $t('about_us.ch2_title') }}</h2>
                <p>{{ $t('about_us.ch2_p1') }}</p>
                <p>{{ $t('about_us.ch2_p2')}}
                    <ul>
                        <li>
                            <p>{{ $t('about_us.ch2_p2_l1')}}</p>
                        </li>
                        <li>
                            <p>{{ $t('about_us.ch2_p2_l2')}}</p>
                        </li>
                        <li>
                            <p>{{ $t('about_us.ch2_p2_l3')}}</p>
                        </li>
                        <li>
                            <p>{{ $t('about_us.ch2_p2_l4')}}</p>
                        </li>
                        <li>
                            <p>{{ $t('about_us.ch2_p2_l5')}}</p>
                        </li>
                        <li>
                            <p>{{ $t('about_us.ch2_p2_l6')}}</p>
                        </li>
                        <li>
                            <p>{{ $t('about_us.ch2_p2_l7')}}</p>
                        </li>
                        <li>
                            <p>{{ $t('about_us.ch2_p2_l8')}}</p>
                        </li>
                        <li>
                            <p>{{ $t('about_us.ch2_p2_l9')}}</p>
                        </li>
                        <li>
                            <p>{{ $t('about_us.ch2_p2_l10')}}</p>
                        </li>
                        <li>
                            <p>{{ $t('about_us.ch2_p2_l11')}}</p>
                        </li>
                        <li>
                            <p>{{ $t('about_us.ch2_p2_l12')}}</p>
                        </li>
                    </ul>
                </p>
                <div class="columns">
                    <div class="column">
                        <img :src="images.sprite[4]"  @click="openImage(4)"/>
                    </div>
                    <div class="column">
                        <img :src="images.sprite[5]"  @click="openImage(5)"/>
                    </div>
                </div>
                <h2 class="title is-2">{{ $t('about_us.ch3_title') }}</h2>
                <p>{{ $t('about_us.ch3_p1') }}</p>
                <p>{{ $t('about_us.ch3_p2')}}</p>
                <div class="columns">
                    <div class="column">
                        <img :src="images.sprite[6]"  @click="openImage(6)"/>
                    </div>
                    <div class="column">
                        <img :src="images.sprite[7]"  @click="openImage(7)"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import EventBus from '../event-bus.js'
    import 'video.js/dist/video-js.css'

    import { videoPlayer } from 'vue-video-player'

    export default {
        data(){
            return {
                images: null,

                playerOptions: {
                    width: '50%',
                    height: '360',
                    autoplay: false,
                    muted: false,
                    language: 'en',
                    playbackRates: [0.7, 1.0, 1.5, 2.0],
                    sources: [{
                        type: "video/mp4",
                        // mp4
                        src: "/vid/school_hymn.mp4",
                    }],
                    poster: "https://surmon-china.github.io/vue-quill-editor/static/images/surmon-1.jpg",
                }
            }
        },
        components: {
            videoPlayer
        },
        methods: {
            openImage(index){
                EventBus.$emit('openGallery', this.images.full, index)
            },
            createDemoImages(){
                var images = {}
                images['full'] = []
                images['sprite'] = []

                for(var i = 0; i < 9; i++){
                    var url = "img/about/pic"+i+".jpg"
                    images['full'][i] = url
                    images['sprite'][i] = url
                }
                this.images = images
            }
        },
        created(){
            this.createDemoImages()
        }
    }
</script>